import React, { useState, useEffect } from "react";
import {
  Button,
  ControlLabel,
  FormControl,
  FormGroup,
  Modal,
} from "react-bootstrap";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const sendPersonData = async (person) => {
  try {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      memberName: person.memberName,
      jobTitle: person.jobTitle,
      telefono: person.Phone,
    });

    var requestOptions = {
      method: 'POST',
      mode: 'no-cors',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    fetch("https://9x7wdvxyd5.execute-api.us-east-2.amazonaws.com/dev/startdirector", requestOptions)
      .then((response) => response.text())
      .then((result) => console.log(result))
      .catch((error) => console.log('error', error));
  } catch (error) {
    console.error("Failed to send person data:", error);
  }
};

// Nueva función para enviar mensaje de WhatsApp
const sendWhatsAppMessage = async (phoneNumber, memberName) => {
  try {
    const response = await fetch("https://1wgz2ld60h.execute-api.us-east-1.amazonaws.com/prod/whatsapp", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        phoneNumber,
        memberName
      })
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to send WhatsApp message: ${errorText}`);
    }

    const result = await response.json();
    console.log('WhatsApp message sent successfully:', result);
    
    // Mostrar mensaje de éxito al usuario
    alert('Mensaje de WhatsApp enviado exitosamente');
  } catch (error) {
    console.error("Failed to send WhatsApp message:", error);
    // Mostrar mensaje de error al usuario
    alert('Error al enviar mensaje de WhatsApp: ' + error.message);
  }
};

const EngagementsSummary = ({
  detectedFaces,
  detectedPeople,
  showFaceBoundingBoxes,
  webcamCoordinates,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [currentPerson, setCurrentPerson] = useState(null);

  useEffect(() => {
    detectedPeople.forEach((person) => {
      if (person.jobTitle) {
        sendPersonData(person);
      }
    });
  }, [detectedPeople]);

  const handleShowModal = (person) => {
    setCurrentPerson(person);
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  const handleSendWhatsApp = () => {
    if (currentPerson && phoneNumber) {
      // Validar formato de número de teléfono
      const formattedPhoneNumber = phoneNumber.replace(/[^\d]/g, '');
      
      if (formattedPhoneNumber.length < 10) {
        alert('Por favor, ingresa un número de teléfono válido');
        return;
      }

      sendWhatsAppMessage(formattedPhoneNumber, currentPerson.memberName);
      handleCloseModal();
    } else {
      alert('Por favor, ingresa un número de teléfono');
    }
  };

  return (
    <div>
      {detectedFaces.map((face, index) => (
        <div key={index}>
          {showFaceBoundingBoxes && (
            <div
              style={{
                border: "1px solid #ef4b26",
                fontWeight: "bold",
                position: "fixed",
                height: webcamCoordinates.height * face.boundingBox.Height,
                left: webcamCoordinates.left + face.boundingBox.Left * webcamCoordinates.width,
                top: webcamCoordinates.top + face.boundingBox.Top * webcamCoordinates.height,
                width: webcamCoordinates.width * face.boundingBox.Width,
              }}
            >
              Persona #{index + 1}
            </div>
          )}
        </div>
      ))}
      {detectedPeople.map((person) => (
        <div key={person.externalImageId}>
          <p>
            <b
               style={{
                fontFamily: "Arial, sans-serif",
                color: "#fff",
                fontSize: "32px",
                marginTop: "0px",
                backgroundColor: "#ef4b26",
                padding: "20px",
                borderRadius: "25px",
                lineHeight: "1.5",
                lineBreak: "auto",
              }}
            >
              ¡Hola, {person.memberName}!
            </b>
          </p>
          <p
            style={{
              fontFamily: "Arial, sans-serif",
              color: "#fff",
              fontSize: "32px",
              marginTop: "0px",
              backgroundColor: "#ef4b26",
              padding: "10px",
              borderRadius: "25px",
            }}
          >
            ¡Gracias por participar en nuestro evento!
          </p>
         <p
            style={{
              fontFamily: "Arial, sans-serif",
              color: "#fff",
              fontSize: "22px",
              marginTop: "-10px",
              backgroundColor: "#ef4b26",
              padding: "20px",
              borderRadius: "25px",
            }}
          >
            Enviamos una confirmación a tu email: <p>{person.jobTitle}</p>
          </p>
          {/* <Button
            onClick={() => handleShowModal(person)}
            style={{
              marginTop: "80px",
              padding: "10px 20px",
              fontSize: "28px",
              fontFamily: "Arial, sans-serif",
              backgroundColor: "#5646ff",
              color: "#fff",
              border: "none",
              borderRadius: "15px",
              lineBreak: "auto",
            }}
          >
               <FontAwesomeIcon icon={faWhatsapp} style={{ marginRight: '15px' }} />
            Enviar por WhatsApp
          </Button> */}
        </div>
      ))}

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Enviar también por WhatsApp</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormGroup controlId="formPhoneNumber">
            <ControlLabel>Teléfono con código país. Ej: 18095551234</ControlLabel>
            <FormControl
              type="text"
              placeholder="Ej: 18095551234"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
            />
          </FormGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleSendWhatsApp}>
            Enviar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default EngagementsSummary;
